import { types, MediaTypesType, IMediaTypes } from '../types/mediaTypes'

export const initialState: IMediaTypes = {
  isLoading: false,
  list: [],
}

export const mediaTypes = (
  state = initialState,
  action: MediaTypesType
): IMediaTypes => {
  switch (action.type) {
    case types.GET_MEDIA_TYPES__STARTED:
      return { ...state, isLoading: true }
    case types.GET_MEDIA_TYPES__SUCCESS:
    case types.UPDATE_MEDIA_TYPES:
      return { ...state, isLoading: false, list: action.list || [] }
    case types.GET_MEDIA_TYPES__FAILURE:
      return { ...state, isLoading: false }
    default:
      return state
  }
}
